<div class="submission-container" [ngClass]="{ 'expiring-soon': submission.expiringSoon, disabled: disabled }">
  <div class="d-flex flex-column w-100">
    <div class="d-flex flex-column gap-2 w-100">
      <div class="d-flex justify-content-between">
        <app-status-pill [statusPill]="submission.statusPill" />
        <div class="sub-id">{{ submission.submissionId }}</div>
      </div>
      <span class="restricted" *ngIf="disabled" i18n>Viewing is restricted</span>
    </div>
    <div class="sub-info">
      <span
        class="sub-info-title"
        [class.disabled]="disabled"
        (click)="!disabled && submissionClicked.emit(submission)">
        {{ submission.submissionTypeName }}
      </span>
      <span class="sub-info-date">{{ submission | submissionStatusDateString : 'MMMM D, YYYY' }}</span>
      <div class="d-flex gap-2 mt-2" *ngIf="submission.expiringSoon">
        <img src="/assets/icons/orange/Clock.svg" alt="Clock" i18n-alt />
        <span i18n>You have until {{ submission.formattedExpirationDate }} to complete this submission</span>
      </div>
    </div>
  </div>
</div>
